import './i18next';

import * as Sentry from '@sentry/browser';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { StrictMode, Suspense } from 'react';

import { App } from './App';
import { AuthProvider } from '@justgiving/auth-react';
import { BrowserRouter } from 'react-router-dom';
import { CharityDataProvider } from './context/charityContext';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { auth } from './auth';
import config from './config';
import { createRoot } from 'react-dom/client';
import { generateRedirectionUrl } from './hooks/useSsoRedirection';

Sentry.init({
  dsn: config.sentryDsn,
  release:
    document
      .querySelector('meta[data-application-version]')
      ?.getAttribute('data-application-version') ?? 'local',
  environment: config.env,
  allowUrls: [/justgiving\.com/, /jg-cdn\.com/],
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 10 * 1000,
      retry: (failureCount, error: any) => {
        if (
          error.response?.errors?.[0]?.extensions?.exception?.responseStatus ===
          401
        ) {
          if (failureCount === 0) {
            return true;
          } else {
            const ssoUrl = generateRedirectionUrl('set_profile');
            window.location.assign(ssoUrl);
          }
        }
        return false;
      },
    },
  },
});

const root = createRoot(document.getElementById('app')!);
root.render(
  <StrictMode>
    <Suspense fallback={<div />}>
      <BrowserRouter>
        <AuthProvider auth={auth}>
          <QueryClientProvider client={queryClient}>
            <CharityDataProvider>
              <App />
            </CharityDataProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </Suspense>
  </StrictMode>,
);
